import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Modal} from "@pg-design/modal-module";
import {useUserDevice} from "@pg-mono/user-device";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {NotificationConsentConfirmation} from "../../../../application/components/NotificationConsentConfirmation";
import {PreferencesModal} from "../../../../application/components/preferences_steps/components/PreferencesModal";
import {IApplication} from "../../../../application/types/IApplication";
import {LeadModalStep} from "../../../../application/types/LeadModalStep";
import {ApplicationSourceSection} from "../../../../application/utils/ApplicationSource";
import {getStoreHash} from "../../../../application/utils/get_store_hash";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import {useOpenedMultileadModalRequiredParams} from "../../hooks/use_multilead_modal_required_params";
import {closeMultilead, resetMultileadState, setMultileadStep} from "../../state/multilead_slice";
import {IMultileadState} from "../../types/IMultileadState";
import {MultileadModalForm} from "./MultileadModalForm";
import {MultileadModalRecommendedPropertiesStep} from "./MultileadModalRecommendedPropertiesStep";

interface IProps {
    property: IPropertyDetail;
    initialStep?: IMultileadState["presentStep"];
}

export const MultileadModal = (props: IProps) => {
    const {property} = props;
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const [mainPropertyApplication, setMainPropertyApplication] = useState<IApplication | null>(null);

    const multilead = useAppSelector((state) => state.multilead);
    const {mainPropertyId, mainVendorId, mainOfferId, sourceSection} = useOpenedMultileadModalRequiredParams();
    const multileadSummaryItems = Object.values(multilead.selectedProperties).map((property) => ({
        ...property,
        offerName: property.offer?.name || "",
        offerType: property.offer?.type,
        offerVendorName: property.offer?.vendor?.name || "",
        offerAddress: property.offer?.address || "",
        offerPrivacyDataProcessorName: "",
        offerPrivacyPolicyUrl: "",
        coordinates: [0, 0] as [number, number],
        mainImage: {}
    }));
    const storeHash = getStoreHash({vendorId: mainVendorId as number, offerId: mainOfferId, propertyId: mainPropertyId});

    const handlers = {
        multileadModal: {
            closeModal: () => {
                dispatch(closeMultilead());
            },
            afterClose: () => {
                dispatch(resetMultileadState());
            }
        },
        preferencesModal: {
            closeModal: () => {
                dispatch(setMultileadStep({step: LeadModalStep.NOTIFICATION_CONSENT}));
            }
        },
        notificationsModal: {
            closeModal: () => {
                dispatch(closeMultilead());
            },
            afterClose: () => {
                dispatch(resetMultileadState());
            }
        }
    };

    useEffect(() => {
        if (multilead.applicationPayload.length > 0) {
            const mainPropertyApplication = multilead.applicationPayload.find(([applicationResponse]) => applicationResponse.property === property.id);
            setMainPropertyApplication(mainPropertyApplication ? mainPropertyApplication[0] : multilead.applicationPayload[0][0]);
        }
    }, [multilead.applicationPayload]);

    return (
        <>
            {/*MULTILEAD MODAL*/}
            <Modal
                isOpen={multilead.isModalOpen}
                className={multileadModalStyle}
                onModalClose={handlers.multileadModal.closeModal}
                onAfterClose={handlers.multileadModal.afterClose}
                showCloseButton
                fullScreen={!!isMobile}
            >
                <Modal.CloseButton placement="right" />
                {multilead.presentStep === LeadModalStep.MULTILEAD && <MultileadModalRecommendedPropertiesStep property={property} />}
                {multilead.presentStep === LeadModalStep.APPLICATION_FORM_STANDARD && <MultileadModalForm property={property} />}
            </Modal>

            {/*PREFERENCES MODAL*/}
            {multilead.presentStep === LeadModalStep.PREFERENCES && (
                <Modal
                    isOpen={multilead.isModalOpen}
                    className={preferencesModalStyle}
                    onModalClose={handlers.preferencesModal.closeModal}
                    fullScreen={!!isMobile}
                >
                    <PreferencesModal
                        applicationPayload={{
                            originalApplicationResponse: mainPropertyApplication,
                            multiLeadSummaryItems: multileadSummaryItems
                        }}
                        onClose={handlers.preferencesModal.closeModal}
                        preferencesSurveySource={PreferencesSurveySource.AFTER_LEAD}
                    />
                </Modal>
            )}

            {/*NOTIFICATION CONSENT MODAL*/}
            {multilead.presentStep === LeadModalStep.NOTIFICATION_CONSENT && (
                <Modal
                    isOpen={multilead.isModalOpen}
                    className={notificationsModalStyle}
                    onModalClose={handlers.notificationsModal.closeModal}
                    onAfterClose={handlers.notificationsModal.afterClose}
                    showCloseButton
                    fullScreen={!!isMobile}
                >
                    <Modal.CloseButton placement="right" />
                    <NotificationConsentConfirmation
                        storeHash={storeHash}
                        result={mainPropertyApplication}
                        onModalClose={handlers.notificationsModal.closeModal}
                        sourceSection={sourceSection ?? ApplicationSourceSection.PREMULTILEAD}
                    />
                </Modal>
            )}
        </>
    );
};

const multileadModalStyle = css({
    md: {
        width: "851px",
        height: "max-content",
        p: 3
    }
});

const preferencesModalStyle = css({
    md: {
        width: "851px",
        height: "max-content"
    }
});

const notificationsModalStyle = css({
    md: {
        width: "851px",
        height: "max-content"
    }
});
import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Modal} from "@pg-design/modal-module";
import {useUserDevice} from "@pg-mono/user-device";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {NotificationConsentConfirmation} from "../../../../application/components/NotificationConsentConfirmation";
import {PreferencesModal} from "../../../../application/components/preferences_steps/components/PreferencesModal";
import {IApplication} from "../../../../application/types/IApplication";
import {LeadModalStep} from "../../../../application/types/LeadModalStep";
import {ApplicationSourceSection} from "../../../../application/utils/ApplicationSource";
import {getStoreHash} from "../../../../application/utils/get_store_hash";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import {useOpenedMultileadModalRequiredParams} from "../../hooks/use_multilead_modal_required_params";
import {closeMultilead, resetMultileadState, setMultileadStep} from "../../state/multilead_slice";
import {IMultileadState} from "../../types/IMultileadState";
import {MultileadModalForm} from "./MultileadModalForm";
import {MultileadModalRecommendedPropertiesStep} from "./MultileadModalRecommendedPropertiesStep";

interface IProps {
    property: IPropertyDetail;
    initialStep?: IMultileadState["presentStep"];
}

export const MultileadModal = (props: IProps) => {
    const {property} = props;
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const [mainPropertyApplication, setMainPropertyApplication] = useState<IApplication | null>(null);

    const multilead = useAppSelector((state) => state.multilead);
    const {mainPropertyId, mainVendorId, mainOfferId, sourceSection} = useOpenedMultileadModalRequiredParams();
    const multileadSummaryItems = Object.values(multilead.selectedProperties).map((property) => ({
        ...property,
        offerName: property.offer?.name || "",
        offerType: property.offer?.type,
        offerVendorName: property.offer?.vendor?.name || "",
        offerAddress: property.offer?.address || "",
        offerPrivacyDataProcessorName: "",
        offerPrivacyPolicyUrl: "",
        coordinates: [0, 0] as [number, number],
        mainImage: {}
    }));
    const storeHash = getStoreHash({vendorId: mainVendorId as number, offerId: mainOfferId, propertyId: mainPropertyId});

    const handlers = {
        multileadModal: {
            closeModal: () => {
                dispatch(closeMultilead());
            },
            afterClose: () => {
                dispatch(resetMultileadState());
            }
        },
        preferencesModal: {
            closeModal: () => {
                dispatch(setMultileadStep({step: LeadModalStep.NOTIFICATION_CONSENT}));
            }
        },
        notificationsModal: {
            closeModal: () => {
                dispatch(closeMultilead());
            },
            afterClose: () => {
                dispatch(resetMultileadState());
            }
        }
    };

    useEffect(() => {
        if (multilead.applicationPayload.length > 0) {
            const mainPropertyApplication = multilead.applicationPayload.find(([applicationResponse]) => applicationResponse.property === property.id);
            setMainPropertyApplication(mainPropertyApplication ? mainPropertyApplication[0] : multilead.applicationPayload[0][0]);
        }
    }, [multilead.applicationPayload]);

    return (
        <>
            {/*MULTILEAD MODAL*/}
            <Modal
                isOpen={multilead.isModalOpen}
                className={multileadModalStyle}
                onModalClose={handlers.multileadModal.closeModal}
                onAfterClose={handlers.multileadModal.afterClose}
                showCloseButton
                fullScreen={!!isMobile}
            >
                <Modal.CloseButton placement="right" />
                {multilead.presentStep === LeadModalStep.MULTILEAD && <MultileadModalRecommendedPropertiesStep property={property} />}
                {multilead.presentStep === LeadModalStep.APPLICATION_FORM_STANDARD && <MultileadModalForm property={property} />}
            </Modal>

            {/*PREFERENCES MODAL*/}
            {multilead.presentStep === LeadModalStep.PREFERENCES && (
                <Modal
                    isOpen={multilead.isModalOpen}
                    className={preferencesModalStyle}
                    onModalClose={handlers.preferencesModal.closeModal}
                    fullScreen={!!isMobile}
                >
                    <PreferencesModal
                        applicationPayload={{
                            originalApplicationResponse: mainPropertyApplication,
                            multiLeadSummaryItems: multileadSummaryItems
                        }}
                        onClose={handlers.preferencesModal.closeModal}
                        preferencesSurveySource={PreferencesSurveySource.AFTER_LEAD}
                    />
                </Modal>
            )}

            {/*NOTIFICATION CONSENT MODAL*/}
            {multilead.presentStep === LeadModalStep.NOTIFICATION_CONSENT && (
                <Modal
                    isOpen={multilead.isModalOpen}
                    className={notificationsModalStyle}
                    onModalClose={handlers.notificationsModal.closeModal}
                    onAfterClose={handlers.notificationsModal.afterClose}
                    showCloseButton
                    fullScreen={!!isMobile}
                >
                    <Modal.CloseButton placement="right" />
                    <NotificationConsentConfirmation
                        storeHash={storeHash}
                        result={mainPropertyApplication}
                        onModalClose={handlers.notificationsModal.closeModal}
                        sourceSection={sourceSection ?? ApplicationSourceSection.PREMULTILEAD}
                    />
                </Modal>
            )}
        </>
    );
};

const multileadModalStyle = css({
    md: {
        width: "851px",
        height: "max-content",
        p: 3
    }
});

const preferencesModalStyle = css({
    md: {
        width: "851px",
        height: "max-content"
    }
});

const notificationsModalStyle = css({
    md: {
        width: "851px",
        height: "max-content"
    }
});
